import React, { useEffect, useState } from "react";

// WriteMessageInPreviewFile: Componente que renderiza el campo para escribir un mensaje 
// asociado al archivo seleccionado dentro de la vista previa "PreviewFileSelected".

const WriteMessageInPreviewFile = ({ fileSelected, setMessagesArray, messagesArray, handleKeyDown }) => {
    
    const [messageByFileSelected, setMessageByFileSelected] = useState(""); //Estado para actualizar el mensaje de acuerdo al archivo seleccionado.

    const onMessageByFileSelected = () => { //Función para actualizar el valor del mensaje según el archivo seleccionado.
        let messageByFileArray = []; //Array que contendrá al "name" y "message" del archivo multimedia en caso de que exista.
        let messageByFile = messagesArray.map( (message) => { //Recorrer la lista de mensajes con los nombres de los archivos
            if (message.name === fileSelected) { //Si existe un mensaje con el nombre del archivo seleccionado.
                /* console.log("esto es el mensaje con su nombre de archivo que le pertenece", message, fileSelected); */
                messageByFileArray.push({ name: fileSelected, message: message.message }); 
                return { ...message, message: message.message };
            }
            return {};
        });    
        
        if(!messageByFileArray.some( (message) => message.name === fileSelected)){
            messageByFile = []; //Borrar todos los elementos dentro del messageByFile.
            /* console.log("no tiene ningún mensaje así que voy a agregar uno nuevo", { name: fileSelected, message: "" }); */
            messageByFile.push({ name: fileSelected, message: "" }); //Asignar nuevos parámetros.
        }
        /* console.log("de acá voy a sacar el mensaje por archivo seleccionado", messageByFileArray); */
        if (messageByFileArray.length > 0) messageByFile = messageByFileArray[0].message 
        else messageByFile = "";
        setMessageByFileSelected(messageByFile);
    };

    const onWriteMessage = (e) => { //Función para escribir un nuevo mensaje en un archivo.
        const newMessage = e.target.value; //Extraer el valor del texto introducido.
        /* console.log("esto es lo que se está introduciendo", `"${newMessage}"`); */
        const updatedMessages = messagesArray.map( (message) => { //Recorrer la lista de mensajes con los nombres de los archivos alos que pertenece.
            if (message.name === fileSelected) { //En caso de que el nombre del archivo coincida con el nombre del file seleccionado.
                /* console.log("esto es el mensaje con su nombre de archivo que le pertenece", message, fileSelected); */
                /* console.log("esto es lo que se retorna", { ...message, message: newMessage }); */
                return { ...message, message: newMessage };
            }
            return message;
        });
        
        if (!updatedMessages.some((message) => message.name === fileSelected)) { // Si no se encontró un mensaje asociado al archivo, se agrega uno nuevo
            /* console.log("esto es lo que se retorna como nuevo mensaje", { name: fileSelected, message: newMessage }); */
            updatedMessages.push({ name: fileSelected, message: newMessage });
        }
        setMessagesArray(updatedMessages);
        setMessageByFileSelected(newMessage);
        /* console.log("esto esta siendo mesaggesArray", messagesArray); */
        /* console.log("esto va teniendo el messageByFileSelected", messageByFileSelected); */
    };

    useEffect(() => {onMessageByFileSelected()}, [fileSelected]); //Se ejecuta cada vez que cambia el archivo seleccionado.

    return (
        <textarea onChange={(e) => onWriteMessage(e)} onKeyDown={handleKeyDown}
            value={messageByFileSelected} placeholder="Escribe tu mensaje..."></textarea>
    )
};

export default WriteMessageInPreviewFile;